/** @jsxImportSource @emotion/react */
import type { ScanPartFieldChange } from '@/Client/Presenters';
import { DEFAULT_TASK_ACTIVITY_LOG_STYLES } from './taskActivityLogStyles';

const styles = DEFAULT_TASK_ACTIVITY_LOG_STYLES;

const ChangeValue = ({ before, after, isModifier }: ScanPartFieldChange) => {
  if (isModifier) return null;
  if (before === after) return <>changed</>;
  return (
    <>
      {before !== undefined && <span css={styles.changeBefore}>{before}</span>}
      {before !== undefined && ' → '}
      {after ?? '—'}
    </>
  );
};

/**
 * An edit's changes as a tooltip's table: each changed field's name, then its value before (struck through) and after.
 * A modifier change ("Deferred added") is its name alone.
 */
export const TaskActivityChangesTooltipTable = ({ changes }: { changes: readonly ScanPartFieldChange[] }) => (
  <table css={styles.changesTable} data-testid={'task-activity-changes'}>
    <tbody>
      {changes.map(change => (
        <tr key={change.field}>
          <td css={styles.changeFieldCell}>{change.field}</td>
          <td css={styles.changeValueCell}>
            <ChangeValue {...change} />
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);
